import React from 'react';
import Util from '../Util';
import Api from '../Api';
import moment from 'moment';

class DashBeatCommand extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: '',
      content: '',
      commandString: '',
      startDate: moment().format('YYYY-MM-DD') + ' 00:00:00',
      endDate: moment().format('YYYY-MM-DD') + ' 23:59:59',
    };
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleButtonClick(type, event) {
    event.preventDefault();

    let { hostInfo } = this.props;
    let { ip, fingerprint } = hostInfo;
    let { commandString, startDate, endDate } = this.state;

    if (this.unmounted) return;

    if (hostInfo.isVPNKskType && !Util.isValidIpAddress(ip)) {
      this.setState({
        content: <span style={{ color: 'red' }}>Invalid ip: {ip}</span>,
      });
      return;
    }

    if (this.inProgress) {
      this.setState({
        content: (
          <div>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <div>Request in Progress!</div>
          </div>
        ),
      });
      return; // stop when other request in progress
    }

    let promise;

    switch (type) {
      case 'listResult': {
        let utcStartDate = moment(startDate, 'YYYY-MM-DD HH:mm:ss')
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
        let utcEndDate = moment(endDate, 'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss');
        promise = Api.listDashBeatCommandsResult(fingerprint, utcStartDate, utcEndDate);
        break;
      }
      case 'addInstallTeamViewer':
        promise = Api.addDashBeatCommand(fingerprint, 'InstallTeamViewer', null);
        break;
      case 'addCustom':
        if (_.isEmpty(commandString)) {
          promise = Promise.reject(new Error('Not adding empty command to queue!'));
        } else {
          promise = Api.addDashBeatCommand(fingerprint, 'Custom', commandString);
        }
        break;
      case 'listQueue':
        promise = Api.listDashBeatCommandsInQueue(fingerprint);
        break;
      case 'clearQueue':
        if (!window.confirm('Continue to clear all pending commands?')) {
          return;
        }
        promise = Api.clearDashBeatCommandsInQueue(fingerprint);
        break;
      default:
        promise = Promise.reject(new Error('invalid type: ' + type));
    }

    this.setState({
      type: type,
      content: <i className='fa fa-spinner fa-spin fa-3x fa-fw' />,
    });

    this.inProgress = true;

    return promise
      .then((data) => {
        this.inProgress = false;

        if (type === 'listResult') {
          this.setState({
            content: (
              <div>
                {data.length === 0 && <div>No result found!</div>}
                {data.map((r) => {
                  // let localDateTime = moment.utc(r.eventDate).local().format('YYYY-MM-DD HH:mm:ss');
                  return (
                    <div style={{ borderBottom: '1px solid #ccc', padding: '15px 5px', margin: 5 }}>
                      <div className='pure-u-3-4' style={{ fontWeight: 'bold' }}>
                        command:
                      </div>
                      <div className='pure-u-1-4' style={{ textAlign: 'right' }}>
                        {Util.xUnitsOfTimeAgo(r.eventDate)} ({Util.localDateTimeString(r.eventDate)}
                        )
                      </div>
                      <div className='pure-u-1-1' style={{}}>
                        <pre style={{ padding: 0, margin: 0, paddingLeft: 5 }}>{r.command}</pre>
                      </div>
                      {r.stderr && (
                        <div style={{ margin: '10px 0' }}>
                          <div className='pure-u-1-4' style={{ fontWeight: 'bold' }}>
                            Error Output (stderr)
                          </div>
                          <div className='pure-u-3-4'></div>
                          <div className='pure-u-1-1'>
                            <pre
                              style={{
                                padding: 0,
                                margin: 0,
                                borderLeft: '0px solid #ccc',
                                paddingLeft: 5,
                                color: 'red',
                              }}
                            >
                              {r.stderr}
                            </pre>
                          </div>
                        </div>
                      )}
                      {r.stdout && (
                        <div style={{ margin: '10px 0' }}>
                          <div className='pure-u-1-4' style={{ fontWeight: 'bold' }}>
                            Output (stdout)
                          </div>
                          <div className='pure-u-3-4'></div>
                          <div className='pure-u-1-1'>
                            <pre
                              style={{
                                padding: 0,
                                margin: 0,
                                borderLeft: '0px solid #ccc',
                                paddingLeft: 5,
                              }}
                            >
                              {r.stdout}
                            </pre>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ),
          });
          return;
        }

        let result = JSON.stringify(data, null, 2);
        this.setState({
          content: <pre style={{ color: '' }}>{result}</pre>,
        });
      })
      .catch((e) => {
        this.inProgress = false;
        this.setState({
          content: <pre style={{ color: 'red' }}>{e.message}</pre>,
        });
      });
  }

  render() {
    let { panelHeight } = this.props;
    let { type, commandString, startDate, endDate } = this.state;

    return (
      <div className='sheldon-content-wrapper'>
        <h2>DashBeat Command</h2>
        <p>
          Schedule a command to be executed in kiosk when kiosk's dashbeat request come in.
          <br />
          Commands are added to a queue and each dashbeat will pop a command from the queue and
          execute the command in kiosk.
          <br />
          And the result of the command execution is sent back to dashweb/dashapi.
        </p>
        <div style={{ textAlign: 'left', marginTop: 10 }}>
          <form className='pure-form' autoComplete='on' style={{ height: 58 }} name='listResult'>
            <fieldset>
              Start Date Time:{' '}
              <input
                className='pure-input-1-6'
                style={{ marginRight: 10 }}
                autoComplete='off'
                autoFocus={true}
                name='startDate'
                placeholder='YYYY-MM-DD HH:mm:ss'
                value={startDate}
                onChange={(event) => this.setState({ startDate: event.target.value })}
              />
              End Date Time:{' '}
              <input
                className='pure-input-1-6'
                style={{ marginRight: 10 }}
                autoComplete='off'
                autoFocus={true}
                name='endDate'
                placeholder='YYYY-MM-DD HH:mm:ss'
                value={endDate}
                onChange={(event) => this.setState({ endDate: event.target.value })}
              />
              <button
                className='pure-input-1-6 pure-button pure-button-primary'
                type='submit'
                onClick={this.handleButtonClick.bind(this, 'listResult')}
              >
                List DashBeat Command Result
              </button>
            </fieldset>
          </form>
        </div>
        <div className='sheldon-buttons'>
          <button
            className={type === 'listQueue' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'listQueue')}
          >
            List Pending Commands in Queue
          </button>
          <button
            className={type === 'clearQueue' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'clearQueue')}
          >
            Clear Pending Commands in Queue
          </button>
          <button
            className={
              type === 'addInstallTeamViewer' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'addInstallTeamViewer')}
          >
            Schedule TeamViewer Install
          </button>
        </div>
        <div style={{ textAlign: 'left', marginTop: 10 }}>
          <form className='pure-form' autoComplete='on' style={{ height: 58 }} name='addCustom'>
            <fieldset>
              Custom Command:{' '}
              <textarea
                className='pure-input-2-3'
                style={{ marginRight: 5 }}
                autoComplete='on'
                autoFocus={true}
                name='commandString'
                placeholder=''
                value={commandString}
                onChange={(event) => this.setState({ commandString: event.target.value })}
              />
              <button
                className='pure-input-1-5 pure-button pure-button-primary'
                type='submit'
                onClick={this.handleButtonClick.bind(this, 'addCustom')}
              >
                Schedule
              </button>
            </fieldset>
          </form>
        </div>
        <div className='sheldon-content sheldon-cmd'>
          <div style={{ height: panelHeight - 400, overflow: 'auto' }} ref='content'>
            {this.state.content}
          </div>
        </div>
      </div>
    );
  }
}

export default DashBeatCommand;



// WEBPACK FOOTER //
// ./src/components/SheldonDashBeatCommand.js